export default {
  title: 'REFERRAL CODE SETTINGS',
  items: {
    RefHostUserCredit: {
      label: 'Amount Credited to User',
      type: 'integer',
      unit: '$'
    },
    RefUserCredit: {
      label: 'Amount Credited to Referrals',
      type: 'integer',
      unit: '$'
    },
    RefCreditValidDay: {
      label: 'No. of Days the Referral Credit is Valid',
      type: 'integer',
      unit: 'days'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/referral-code-settings.js